import { Amplify } from 'aws-amplify';

const userPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID || '';
const userPoolClientId = process.env.REACT_APP_COGNITO_CLIENT_ID || '';
const region = process.env.REACT_APP_COGNITO_REGION || 'us-east-1';

/**
 * Whether real Cognito configuration is present.
 *
 * The app build FAILS CLOSED on this: when it is false, App renders a
 * configuration error instead of an auth-disabled state. Placeholder pool ids
 * (empty / XXXX / DEVMODE) count as "not configured" so a misbuilt bundle can
 * never run with authentication silently disabled.
 */
export const isCognitoConfigured =
  !!userPoolId.trim() &&
  !userPoolId.includes('XXXX') &&
  !userPoolId.includes('DEVMODE') &&
  !!userPoolClientId.trim();

const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId,
      userPoolClientId,
      region,
      loginWith: {
        email: true,
      },
    },
  },
};

if (isCognitoConfigured) {
  Amplify.configure(amplifyConfig);
}

export default amplifyConfig;
